/**
 * TEMPORARY: Region-specific details for Lunar New Year site takeover only.
 * Used because LAB cannot currently set content per region.
 * Remove when LAB supports region-based messaging or after lunar-new-year campaign ends.
 *
 * Theme id must be exactly "lunar-new-year" (from siteTakeoverTheme.id).
 */

import { defineMessage, type MessageDescriptor } from 'react-intl'

export const LUNAR_NEW_YEAR_THEME_ID = 'lunar-new-year'

interface LunarNewYearRegionAmounts {
  silverAmount: MessageDescriptor
  goldAmount: MessageDescriptor
}

const LUNAR_NEW_YEAR_AMOUNTS_BY_REGION: Readonly<Record<string, LunarNewYearRegionAmounts>> = {
  SG: {
    silverAmount: defineMessage({
      id: '58dttzGDhq',
      defaultMessage: 'S$1,000',
      description: 'Silver tier spend threshold for Singapore region in Lunar New Year campaign',
    }),
    goldAmount: defineMessage({
      id: 'A7o/GiTLuP',
      defaultMessage: 'S$3,000',
      description: 'Gold tier spend threshold for Singapore region in Lunar New Year campaign',
    }),
  },
  MY: {
    silverAmount: defineMessage({
      id: 'gCxFg/23e/',
      defaultMessage: 'RM3,200',
      description: 'Silver tier spend threshold for Malaysia region in Lunar New Year campaign',
    }),
    goldAmount: defineMessage({
      id: 'RGeheLNkHq',
      defaultMessage: 'RM9,500',
      description: 'Gold tier spend threshold for Malaysia region in Lunar New Year campaign',
    }),
  },
  HK: {
    silverAmount: defineMessage({
      id: 'oNY4NqKE1j',
      defaultMessage: 'HK$6,000',
      description: 'Silver tier spend threshold for Hong Kong region in Lunar New Year campaign',
    }),
    goldAmount: defineMessage({
      id: 'rYvX7maacc',
      defaultMessage: 'HK$18,200',
      description: 'Gold tier spend threshold for Hong Kong region in Lunar New Year campaign',
    }),
  },
  ZA: {
    silverAmount: defineMessage({
      id: '/1iUZ9XJ8S',
      defaultMessage: 'ZAR13,000',
      description: 'Silver tier spend threshold for South Africa region in Lunar New Year campaign',
    }),
    goldAmount: defineMessage({
      id: 'z/5juhu5mv',
      defaultMessage: 'ZAR38,000',
      description: 'Gold tier spend threshold for South Africa region in Lunar New Year campaign',
    }),
  },
}

/**
 * Returns region-specific loyalty spend amounts for the Lunar New Year campaign, or undefined if none for this region.
 * @param regionCode - current region code (e.g. from GeoContext), case-insensitive for lookup
 */
export function getLunarNewYearRegionAmounts(
  regionCode: string | undefined,
): LunarNewYearRegionAmounts | undefined {
  if (!regionCode) {
    return undefined
  }
  const key = regionCode.toUpperCase()
  return LUNAR_NEW_YEAR_AMOUNTS_BY_REGION[key]
}
